import { render, staticRenderFns } from "./nowaskme.vue?vue&type=template&id=1b551873&"
import script from "./nowaskme.vue?vue&type=script&lang=js&"
export * from "./nowaskme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports